import { axiosInstance } from "../axios/axios"

export const getRegions = async () => {
    try {
        const result = await axiosInstance.get('/get-regions')
        return result.data.data
    } catch (error) {
        console.log(error)
    }
}